import { dcTag } from './dcTag.model';
import { Dictionary } from './dictionary';
import { GenericValue } from './generic-value.model';

export class dcSearchTags {
  public Filter: dcTag[];
  public Target?: dcTag[];
  public IsGroup?: boolean;
  public IsElement?: boolean;
  public Category?: number;
  public CheckForSelfTag?: boolean;
  public ParentId?: number;
  public ParentElementTypeID?: number;
}

export class TagFilter {
  FilterIDs: number[];
  Tag: dcTag;
  MethodParams: Dictionary<GenericValue> = null;
  constructor(tag: dcTag, ids?: number[], params?: Dictionary<GenericValue>) {
    this.Tag = tag;
    this.FilterIDs = ids;
    this.MethodParams = params;
  }
}
